import { RichTextInputAreaUniDriver } from './RichTextInputArea.uni.driver';
import { RichTextToolbarPrivateUniDriver } from './Toolbar/RichTextToolbar.private.uni.driver';

export interface RichTextInputAreaPrivateUniDriver
  extends RichTextInputAreaUniDriver,
    RichTextToolbarPrivateUniDriver {
  // TODO: strongly type private methods
}
